import { getQueryParams } from './getQueryParams.ts';

/** Gets the query param from search string, defaults to the one from locationProvider */
export function getQueryParam<T extends string | boolean = string | boolean>(name: string, search?: string): T | undefined {
  return getQueryParams(search)[name] as T | undefined;
}